module.exports = "<div ui-view></div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/admin/admin.html
// module id = 740
// module chunks = 0